import { queryClient, useMutation } from '../../../../ReactQuery';
import { remove } from '../../../../redux/api';
import type { GetTeamGroupsResponse } from '../../../../../shared/types/routes/teamGroups';

import { useTeamGroupsQueryKey } from './useTeamGroups';

//  Function for deleting a TeamGroup.
function deleteTeamGroup(teamGroupId: number) {
  return remove<void, void>(`/api/teams/groups/${teamGroupId}`);
}

/**
 * Hook used to delete a TeamGroup.
 */
export default function useDeleteTeamGroup(teamGroupId: number) {
  return useMutation({
    mutationFn: () => deleteTeamGroup(teamGroupId),
    onSuccess: () => {
      //  Remove the team group from the cache
      queryClient.setQueryData(useTeamGroupsQueryKey, (oldData?: GetTeamGroupsResponse) => {
        if (!oldData) {
          return [] as GetTeamGroupsResponse;
        }
        return oldData.filter((teamGroup) => teamGroup.id !== teamGroupId);
      });
    },
  });
}
